"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.Graphene = exports.DEFAULT_INACTIVE_THRESHOLD = void 0;
var metrics_utils_1 = require("@snapchat/metrics-utils");
var isInBrowser_1 = require("@snapchat/metrics-utils/lib/utils/isInBrowser");
var ActivityDetector_1 = __importDefault(require("./ActivityDetector"));
exports.DEFAULT_INACTIVE_THRESHOLD = 60;
var Graphene = (function (_super) {
    __extends(Graphene, _super);
    function Graphene() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.sendHeartBeatCounter = function (version) {
            if (!_this.isInitialized) {
                return;
            }
            var heartBeatDuration = 60000;
            var sendHeartBeatEvent = function () {
                var _a;
                var active = ((_a = _this.activityDetector) === null || _a === void 0 ? void 0 : _a.getIsActive()) ? 'active' : 'inactive';
                _this.increment({ metricsName: 'heart_beat', dimensions: { version: version, active: active } });
            };
            sendHeartBeatEvent();
            _this.heartBeatId = setInterval(sendHeartBeatEvent, heartBeatDuration);
        };
        return _this;
    }
    Graphene.prototype.initialize = function (props) {
        if (this.isInitialized) {
            throw new Error('this instance has been initialized. Can\'t re-initialize it.');
        }
        _super.prototype.initialize.call(this, props);
        var _a = props.inactiveThresholdInSecond, inactiveThresholdInSecond = _a === void 0 ? exports.DEFAULT_INACTIVE_THRESHOLD : _a;
        if (isInBrowser_1.isInWindow()) {
            this.activityDetector = new ActivityDetector_1["default"](inactiveThresholdInSecond);
            window.addEventListener('beforeunload', this.flush);
        }
    };
    Graphene.prototype.destroy = function () {
        _super.prototype.destroy.call(this);
        if (isInBrowser_1.isInWindow()) {
            window.removeEventListener('beforeunload', this.flush);
        }
        if (this.activityDetector) {
            this.activityDetector.destroy();
        }
    };
    return Graphene;
}(metrics_utils_1.BaseClient));
exports.Graphene = Graphene;
var graphene = new Graphene();
exports["default"] = graphene;
//# sourceMappingURL=graphene.js.map